import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

// components
import Heading from '../../../components/text/Heading/Heading.component'
import ActionButton from '../../../components/buttons/ActionButton/ActionButton.component'
import CardContainer from '../../../components/cards/CardContainer/CardContainer.component'

// collections
import InventoryEquipmentRequests from './collections/InventoryEquipmentRequests.collection'
import InventoryPurchaseOrders from './collections/InventoryPurchaseOrders.collection'

// forms
import ReceivingLogFormController from './forms/ReceivingLog/ReceivingLog.form.controller'
import ShippingLogFormController from './forms/ShippingLog/ShippingLog.form.controller'
import AdjustmentLogFormController from './forms/AdjustmentLog/AdjustmentLog.form.controller'
import CycleCountLogFormController from './forms/CycleCountLog/CycleCountLog.form.controller'

// utils
import { createUserGroupList, checkIfUserHasGroup } from '../../../shared/privileges/userGroups'

// mui
import { Typography, Grid, Container, ButtonGroup } from '@mui/material'

export default function InventoryDashboard({ usersGroups }) {
    const groups = createUserGroupList(usersGroups)

    let history = useHistory()

    function navigateToEquipmentList() {
        history.push('/inventory/equipment')
    }

    // modals
    const [showReceiving, setShowReceiving] = useState(false)
    const [showShipping, setShowShipping] = useState(false)
    const [showAdjustment, setShowAdjustment] = useState(false)
    const [showCycle, setShowCycle] = useState(false)

    return (<div id="Inventory">

        <ReceivingLogFormController 
            visible={showReceiving}
            closeForm={() => setShowReceiving(false)}
        />

        <ShippingLogFormController 
            visible={showShipping}
            closeForm={() => setShowShipping(false)}
        />

        <AdjustmentLogFormController 
            visible={showAdjustment}
            closeForm={() => setShowAdjustment(false)}
        />

        <CycleCountLogFormController 
            visible={showCycle}
            closeForm={() => setShowCycle(false)}
        />

        <Container maxWidth sx={{ marginBottom: 4}} disableGutters>
            <Grid container spacing={2} justifyContent="center">
                <Grid item xs={6}><Typography variant="h2">Inventory</Typography></Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={6}><ActionButton label="View Equipment" color="secondary" onClick={() => navigateToEquipmentList()}/></Grid>
                <Grid item xs={6} textAlign='right'>
                    <ButtonGroup>
                        
                        { 
                            checkIfUserHasGroup(groups, ["Admin", "ReceivingLimitedAccess"]) && <ActionButton label="Receiving" color="secondary" onClick={() => setShowReceiving(true)}/>
                        }
                        { 
                            checkIfUserHasGroup(groups, ["Admin"]) && <ActionButton label="Shipping" color="secondary" onClick={() => setShowShipping(true)} />
                        }
                        { 
                            checkIfUserHasGroup(groups, ["Admin"]) && <ActionButton label="Make Adjustment" color="secondary" onClick={() => setShowAdjustment(true)} />
                        }
                        { 
                            checkIfUserHasGroup(groups, ["Admin"]) && <ActionButton label="Cycle Count" color="secondary" onClick={() => setShowCycle(true)} />
                        }
                        
                    </ButtonGroup>
                </Grid>
            </Grid>
            
            
        </Container>

        

        <Container maxWidth disableGutters>
            <Grid container spacing={2} justifyContent='space-between'>

                <Grid item xs={6}><InventoryEquipmentRequests status='S' /></Grid>
                {
                    groups.includes("Admin") &&

                    <Grid item xs={6}><InventoryPurchaseOrders status='O' /></Grid>
                }
                
            </Grid>
        </Container>

    </div>)
}